import { LogoProps } from './types';

export const Google = ({ size = 24 }: LogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.57374 0.521731C3.97509 1.07632 2.59642 2.12894 1.64023 3.52498C0.684041 4.92103 0.200732 6.58691 0.261296 8.27794C0.32186 9.96897 0.923104 11.596 1.97671 12.9201C3.03032 14.2441 4.48077 15.1954 6.11499 15.6342C7.4399 15.9761 8.828 15.9911 10.16 15.678C11.3666 15.4069 12.4822 14.8272 13.3975 13.9955C14.3501 13.1034 15.0415 11.9686 15.3975 10.713C15.7843 9.34755 15.8531 7.91166 15.5987 6.51548H8.15874V9.60173H12.4675C12.3814 10.094 12.1968 10.5638 11.9249 10.983C11.653 11.4023 11.2993 11.7624 10.885 12.0417C10.3589 12.3899 9.76578 12.6241 9.14374 12.7292C8.51993 12.8453 7.88006 12.8453 7.25624 12.7292C6.62393 12.5986 6.02579 12.3377 5.49999 11.963C4.65518 11.365 4.02084 10.5154 3.68749 9.53548C3.3486 8.53721 3.3486 7.455 3.68749 6.45673C3.92478 5.757 4.31703 5.1199 4.83499 4.59298C5.42773 3.97891 6.17816 3.53998 7.00394 3.32433C7.82972 3.10868 8.69894 3.12464 9.51624 3.37048C10.1547 3.56639 10.7386 3.90883 11.2212 4.37048C11.7071 3.88715 12.1921 3.40256 12.6762 2.91673C12.9262 2.65548 13.1987 2.40673 13.445 2.13923C12.7082 1.45363 11.8433 0.920111 10.9 0.569231C9.18212 -0.0545317 7.30246 -0.0712947 5.57374 0.521731Z"
      fill="#DFDFDF"
    />
  </svg>
);

export default Google;
